<template>
  <StepLayout
    :on-back="onBack"
    :on-save="onSave"
    :is-busy-on-save="isBusyOnSave"
    :on-next="onNext"
    :is-busy-on-next="isBusyOnNext"
    :is-disabled="isDisabled"
    step-navigation-button-data-ec="bulk_send_name_page"
  >
    <template v-slot:title>
      {{
        isCreateRoute
          ? $t('bulkSend.steps.name.title.create')
          : $t('bulkSend.steps.name.title.edit')
      }}
    </template>
    <form @submit.prevent="handleFormSubmit">
      <p class="text-black mb-lg">{{ $t('bulkSend.steps.name.description') }}</p>
      <FloatingLabelInput
        v-model.trim="name"
        aria-label="name"
        :placeholder="$t('bulkSend.steps.name.placeholder')"
        data-ec="bulk_send_name_page"
        data-et="name_input"
      />
    </form>
  </StepLayout>
</template>

<script>
import { computed, ref } from 'vue';
import { useGetters } from 'vuex-composition-helpers/dist';

import useBulkSendRoutes from '@/composables/bulkSend/routes';
import { useBulkSendStepsNavigation } from '@/composables/bulkSend/steps';

import StepLayout from '@/components/ui/bulkSend/StepLayout.vue';
import FloatingLabelInput from '@/components/tailwind/forms/FloatingLabelInput.vue';

export default {
  name: 'NamePage',
  components: {
    StepLayout,
    FloatingLabelInput,
  },
  setup() {
    // get bulk send data
    // @ts-ignore - useGetters has bad types
    const { bulkSend } = useGetters({ bulkSend: 'bulkSend/bulkSend' });
    const { isCreateRoute } = useBulkSendRoutes();

    // initialise local state
    const name = ref(bulkSend.value.name);

    const updateValue = computed(() => ({ name: name.value }));
    const isValid = computed(() => !!name.value);

    // Tell bulk send steps the action and
    // the data to dispatch update when navigating to next page
    const {
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
    } = useBulkSendStepsNavigation(
      'bulkSend/updateBulkSend',
      updateValue,
      isValid,
    );

    function handleFormSubmit() {
      if (isBusyOnSave.value || isBusyOnNext.value) {
        return;
      }

      if (onNext.value !== undefined) {
        onNext.value();
      }
    }

    return {
      name,
      bulkSend,
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
      isCreateRoute,
      handleFormSubmit,
    };
  },
};
</script>
